export const env = window.__env__ || {}
env.API_URL = env.API_URL || process.env.VUE_APP_API_URL
env.API_ENV = env.API_ENV || process.env.VUE_APP_API_ENV
env.AUTH_COOKIE = env.AUTH_COOKIE || process.env.VUE_APP_AUTH_COOKIE
env.TOKEN = env.TOKEN || process.env.VUE_APP_TOKEN

export default ({ Vue }) => {
  Vue.prototype.$env = env
}
